import * as React from "react";

import { Button } from "@common/components/Atoms/Button";
import { SearchEntry } from "@common/components/Atoms/SearchFilters";
import Dropdown, { DropdownItem, DropdownMenu } from "@common/components/Molecules/Dropdown";

/*===========================================================================
  Page-level search controls for page > header > center
/*======================================================================== */
interface ReferralsPageHeaderCenterProps {
    onKeywordSubmit: (keyword: string) => void;
    keyword: string;
}

export const ReferralsPageHeaderCenter: React.SFC<ReferralsPageHeaderCenterProps> = (
    props: ReferralsPageHeaderCenterProps
) => (
    <div className="c-page__searches">
        <SearchEntry
            label="keywords"
            submitOnEnter={true}
            onSubmit={props.onKeywordSubmit}
            value={props.keyword}
        />
    </div>
);

/*===========================================================================
  Page-level actions for <= small screens
/*======================================================================== */
interface ReferralsSortDropdownProps {
    keyword?: string;
    onSortChange: (string) => void;
}

export const ReferralsSortDropdown: React.SFC<ReferralsSortDropdownProps> = (
    props: ReferralsSortDropdownProps
) => (
    <Dropdown right={true}>
        <Button
            id="referral-sort-drop-down-button"
            dropdown={true}
            className="c-dropdown__toggle"
            onClick={() => console.log("TODO: open dropdown")}>
            sort
        </Button>
        <DropdownMenu>
            <DropdownItem
                onClick={() => {
                    props.onSortChange("1");
                }}>
                name
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange("4");
                }}>
                job
            </DropdownItem>
            <DropdownItem
                onClick={() => {
                    props.onSortChange("2");
                }}>
                stage
            </DropdownItem>
        </DropdownMenu>
    </Dropdown>
);
